import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { TimeCardService } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { User } from 'projects/core/src/lib/login/data/user';
import { VacationDaysService } from '../data/vacation-days.service';
import {
  VacationEventsStore
} from 'projects/desktop/src/app/modules/timesheets/view/vacation-calendar/data/vacation-events.store';
import {
  VacationEventsQuery
} from 'projects/desktop/src/app/modules/timesheets/view/vacation-calendar/data/vacation-events.query';
import { DeviceDetectorService } from 'ngx-device-detector';
import moment from 'moment';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';

@Component({
  selector: 'app-vacation-pdf-generate-dialog',
  templateUrl: './vacation-pdf-generate-dialog.component.html',
  styleUrls: ['./vacation-pdf-generate-dialog.component.scss'],
  providers: [
    VacationEventsStore,
    VacationDaysService,
    VacationEventsQuery,
    DeviceDetectorService
  ]
})
export class VacationPdfGenerateDialogComponent implements OnInit {
  users: User[] = [];
  currentUser: User;
  selectedUsers: User[] = [];

  startDate: Date = moment().startOf('year').toDate();
  endDate: Date = moment().endOf('year').toDate();

  generateLoading = false;

  constructor(
    protected dialogRef: MatDialogRef<VacationPdfGenerateDialogComponent>,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    protected userService: UserService,
    protected timeCardService: TimeCardService,
    protected vacationDaysService: VacationDaysService,
    protected miscSnackBarService: MiscSnackBarService
  ) {
  }

  ngOnInit(): void {
    this.userService.getActiveUsers().subscribe(users => {
      this.users = users
    }, error => {
      this.miscSnackBarService.openErrorSnackBar('Error!')
      this.dialogRef.close()
    })
  }

  generatePdf() {
    const dateFrom = moment(this.startDate).format('YYYY-MM-DD');
    const dateTo = moment(this.endDate).format('YYYY-MM-DD');

    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: 'PTO',
        link: `/time_card/vacation/report/${dateFrom}:${dateTo}?userIds=${this.selectedUsers.map(us => us.id).join(',')}`,
        showSendButton: false

      },
      panelClass: 'pdf-preview-dialog'
    });

    this.dialogRef.close()
  }

  disableClose() {
    this.dialogRef.disableClose = true;
    this.blurActiveElement()
  }

  enableClose() {
    this.dialogRef.disableClose = false;
  }

  blurActiveElement() {
    setTimeout(() => {
      const activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }

}
